import styled, { css, keyframes } from 'styled-components';

const pulseConnecting = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.03); opacity: 0.8; }
`;

export const Container = styled.div`
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    bottom: 100px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const VoiceButton = styled.button<{ $connecting?: boolean }>`
  background: rgba(0, 200, 255, 0.2);
  border: 1px solid rgba(0, 200, 255, 0.6);
  border-radius: 25px;
  color: white;
  padding: 15px 30px;
  font-family: 'Adam', 'Rajdhani', sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1em;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  white-space: nowrap;

  ${({ $connecting }) =>
    $connecting &&
    css`
      border-color: #ffaa00;
      color: #ffaa00;
      box-shadow:
        0 0 20px rgba(255, 170, 0, 0.4),
        inset 0 0 20px rgba(255, 170, 0, 0.1);
      animation: ${pulseConnecting} 1.5s ease-in-out infinite;
    `}

  @media (max-width: 768px) {
    height: 40px;
    padding: 0 28px;
    font-size: 15px;
    border-radius: 10px;
  }
`;

export const Equalizer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(0, 255, 136, 0.3);
  border-radius: 16px;
  padding: 10px 16px;
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    padding: 6px 10px;
  }
`;

export const EqCanvas = styled.canvas`
  display: block;

  @media (max-width: 768px) {
    width: 160px;
    height: 40px;
  }
`;

export const SophieCircle = styled.canvas`
  display: block;
`;

export const CloseButton = styled.button`
  background: none;
  border: 1px solid rgba(255, 100, 100, 0.4);
  color: #ff6464;
  font-size: 16px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 100, 100, 0.15);
    box-shadow: 0 0 10px rgba(255, 100, 100, 0.3);
  }
`;

export const TextButton = styled.button<{ $active?: boolean }>`
  background: rgba(155, 89, 182, 0.2);
  border: 1px solid rgba(155, 89, 182, 0.6);
  border-radius: 25px;
  color: white;
  padding: 15px 30px;
  font-family: 'Adam', 'Rajdhani', sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1em;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  white-space: nowrap;

  ${({ $active }) =>
    $active &&
    css`
      border-color: rgba(155, 89, 182, 1);
      background: rgba(155, 89, 182, 0.35);
      box-shadow:
        0 0 20px rgba(155, 89, 182, 0.4),
        inset 0 0 20px rgba(155, 89, 182, 0.1);
    `}

  @media (max-width: 768px) {
    height: 40px;
    padding: 0 28px;
    font-size: 15px;
    border-radius: 10px;
  }
`;

export const CloseAssistantButton = styled.button`
  background: rgba(255, 70, 70, 0.15);
  border: 1px solid rgba(255, 70, 70, 0.5);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;
    color: rgba(255, 120, 120, 0.9);
  }

  &:hover {
    background: rgba(255, 70, 70, 0.25);
    box-shadow: 0 0 12px rgba(255, 70, 70, 0.3);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
